module.exports = __webpack_public_path__ + "assets/img/juqu_content_2.b77754ce.png";